import Dexie, { type Table } from 'dexie';

// Interfaces mirroring backend models
export const VehicleType = {
    AUTO: 'AUTO',
    MOTO: 'MOTO',
    CAMIONETA: 'CAMIONETA',
    CAMION: 'CAMION',
    BICICLETA: 'BICICLETA'
} as const;
export type VehicleType = typeof VehicleType[keyof typeof VehicleType];

export const MovementType = {
    ENTRADA: 'ENTRADA',
    SALIDA: 'SALIDA'
} as const;
export type MovementType = typeof MovementType[keyof typeof MovementType];

export interface LocalRate {
    id: string;
    tipoVehiculo: VehicleType;
    tarifaBase: number;
    minutosGratis: number;
    fraccionMinutos: number;
    valorFraccion: number;
    tarifaMaximaDia: number;
    companyId: string;
    updatedAt: string; // ISO string
}

export interface LocalMovement {
    id: string;
    tipoMovimiento: MovementType;
    horaEntrada: string; // ISO string
    horaSalida?: string; // ISO string
    placa: string;
    vehiculoId?: string; // Optional if created offline
    status: 'ACTIVO' | 'FINALIZADO';
    esContrato: boolean;
    usaCupoContrato?: boolean;
    synced: boolean;
    companyId: string;
}

export interface LocalTicket {
    id: string;
    numero: string;
    placa: string;
    horaEntrada: string;
    companyId: string;
    status: 'ACTIVO' | 'PAGADO';
}

export interface PendingAction {
    id: string;
    type: 'ENTRY' | 'EXIT';
    payload: any;
    timestamp: number;
    companyId: string;
}

export interface LocalContract {
    id: string;
    placa: string;
    companyId: string;
    fechaInicio: string; // ISO string
    fechaFin: string; // ISO string
    status: 'ACTIVO' | 'VENCIDO' | 'CANCELADO';
    clienteNombre: string;
}

export class ParqiumDatabase extends Dexie {
    rates!: Table<LocalRate>;
    movements!: Table<LocalMovement>;
    tickets!: Table<LocalTicket>;
    pendingQueue!: Table<PendingAction>;
    contracts!: Table<LocalContract>;

    constructor() {
        super('ParqiumOfflineDB');

        this.version(1).stores({
            rates: 'id, companyId, tipoVehiculo',
            movements: 'id, placa, status, companyId, [companyId+status]',
            tickets: 'id, numero, placa, companyId, [companyId+status]',
            pendingQueue: 'id, type, companyId'
        });

        // Version 2: Add timestamp index to pendingQueue
        this.version(2).stores({
            pendingQueue: 'id, type, companyId, timestamp'
        });

        // Version 3: Add contracts table
        this.version(3).stores({
            contracts: 'id, placa, companyId, status, [companyId+placa]'
        });

        // Version 4: Update movements with usaCupoContrato (no schema change needed for the field itself in Dexie if not indexed)
        this.version(4).stores({
            movements: 'id, placa, status, companyId, [companyId+status], usaCupoContrato'
        });
    }
}

export const db = new ParqiumDatabase();
